// extracted by mini-css-extract-plugin
export default {"wrapper":"TableContainer_wrapper__QakKL","button":"TableContainer_button__TZLSs"};